import React from 'react';
import { CTAButton } from './CTAButton';
const pills = ['120 kart do wydrukowania', 'Bez kupowania zestawów', 'Dostęp zaraz po zakupie'];
export function Hero() {
  return <section className="w-full bg-background px-5 pb-14 pt-10 sm:pb-20 sm:pt-14" data-id="element-121" data-mp="9ktefowaq4ya">
      <div className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-122" data-mp="9igxnf29y0mt">
        <span className="inline-block rounded-full border border-foreground/15 bg-card px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-foreground shadow-sm sm:text-[11px]" data-id="element-123" data-mp="4njpeactjvaz">
          <span className="text-highlight" aria-hidden="true" data-id="element-124" data-mp="xb5s7ge82vws">
            ✦
          </span>{' '}
          120 PROJEKTÓW STEM DO ZBUDOWANIA W DOMU
        </span>

        <h1 className="mt-6 max-w-3xl font-display text-[30px] font-bold leading-[1.08] tracking-tight text-foreground sm:text-[48px] md:text-[60px]" data-id="element-125" data-mp="nczvreb6qhzb">
          Wystarczy jedno popołudnie, a Twoje dziecko zbuduje{' '}
          <span className="text-accent" data-id="element-126" data-mp="381nrczkpyaz7">prawdziwy wynalazek</span>.{' '}
          <span className="text-accent" data-id="element-127" data-mp="3j896f9neq5ny">Z rzeczy, które już masz w domu</span>.
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground/75 sm:text-lg" data-id="element-128" data-mp="3o85a17s6zv2z">
          To nie jest kolejny sposób, żeby dziecko „czymś się zajęło”. To 120 projektów do zrobienia
          własnymi rękami. Dzieci w wieku 5–12 lat wymyślają, budują, testują i z dumą wołają:
          „Patrz, działa!”.
        </p>

        <ul className="mt-7 flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-129" data-mp="30h9djxcskbpe">
          {pills.map(pill => <li key={pill} className="flex items-center gap-2 rounded-full border border-primary/20 bg-secondary px-4 py-2 text-xs font-bold text-foreground sm:text-sm" data-id="element-130" data-mp="35aucbrm7l9pn">
              <span className="text-success" aria-hidden="true" data-id="element-131" data-mp="2vglld8cttotl">
                ✓
              </span>
              {pill}
            </li>)}
        </ul>

        <div className="mt-9 w-full max-w-md" data-id="element-132" data-mp="2lk8v6kghpt3l">
          <CTAButton label="CHCĘ PRACOWNIĘ MAŁEGO WYNALAZCY" data-id="element-133" data-mp="s1rqcip57wrn" />
          <p className="mt-3 text-xs font-semibold text-foreground/70 sm:text-sm" data-id="element-134" data-mp="s3cmudv0pps5">
            Płacisz raz · Pliki do pobrania · Dla dzieci 5–12 lat
          </p>
        </div>

        <figure className="mt-10 w-full max-w-[880px] sm:mt-12" data-id="element-135" data-mp="id02omr47ymj">
          <div className="relative overflow-hidden rounded-hero bg-card shadow-hero" data-id="element-136" data-mp="ddnhe6fw6zm2">
            <img src="https://cdn.magicpatterns.com/uploads/jze1DvQSNW9NBNp8Aujw8J/young-inventor-lab-hero-16x9.webp" alt="Two children at a sunlit table building a balloon-powered car and a balance bird, with printed Young Inventor Lab build cards in front of them" width="1600" height="900" loading="eager" decoding="async" sizes="(max-width: 880px) calc(100vw - 40px), 880px" className="block aspect-[16/9] w-full object-cover" data-id="element-137" data-mp="1b0w05toidukd" />
            <div className="pointer-events-none absolute inset-0 rounded-hero ring-1 ring-inset ring-card/40" aria-hidden="true" data-id="element-138" data-mp="3hpsft8nytx3m" />
          </div>
        </figure>
      </div>
    </section>;
}